import { jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { ProjectProvider } from '../contexts/ProjectContext';
/**
 * Layout wrapper for all /proposal/:id/* routes.
 * Provides ProjectContext (using param "id" as projectId) to nested routes.
 */ export function ProposalLayout() {
    return /*#__PURE__*/ _jsx(ProjectProvider, {
        children: /*#__PURE__*/ _jsx(Outlet, {})
    });
}
